import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

import { DoodleIcon, directionIcons } from "./DoodleIcon";

const categoryLabels = {"Веб разработка":"Веб-разработка", "Веб Дизайн":"Веб-дизайн", "CMS и Конструкторы":"CMS и конструкторы", "Искусственный интеллект":"Нейросети"};
const lessonLabel = n => n % 10 === 1 && n % 100 !== 11 ? "урок" : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 12 || n % 100 > 14) ? "урока" : "уроков";

export const CourseCard = ({ course, carousel = false, testId }) => (
  <Link to={`/course/${course.slug}`} className={`paper-course-card${carousel ? " paper-course-carousel" : ""}`} data-testid={testId || `course-card-${course.slug}`}>
    <img className="paper-course-cover" src={course.image} alt="" loading="lazy" decoding="async" />
    <span className="paper-course-tape" aria-hidden="true" />
    <div className="paper-course-top"><span className="paper-course-category"><DoodleIcon name={directionIcons[course.category] || "book"} size={22} />{categoryLabels[course.category] || course.category}</span></div>
    <h3>{course.title}</h3>
    <p className="paper-course-description">{course.description}</p>
    <div className="paper-course-meta">
      {course.lessons > 0 && <span><DoodleIcon name="book" size={18} />{course.lessons} {lessonLabel(course.lessons)}</span>}
      {course.duration && <span><DoodleIcon name="clock" size={18} />{course.duration}</span>}
    </div>
    <div className="paper-course-footer">
      <div className="paper-course-price"><strong>{course.price.toLocaleString("ru-RU")} ₽</strong>{course.originalPrice > course.price && <div><s>{course.originalPrice.toLocaleString("ru-RU")} ₽</s>{course.discount > 0 && <span className="paper-course-saving">−{course.discount}%</span>}</div>}</div>
      <span className="paper-course-action"><span className="paper-course-action-label">Подробнее</span> <ArrowRight size={18} aria-hidden="true" /></span>
    </div>
  </Link>
);
